import { Typography } from "antd"
import cx from "clsx"
import { useCallback } from "react"
import styles from "./index.module.less"

const { Text: AntdText } = Typography

const Text = props => {
  const { children, block = false, className, style, ...rest } = props

  const renderComponent = useCallback(() => {
    return (
      <AntdText
        className={cx(styles.typography, rest.type && styles[`ant-typography-${rest.type}`], className)}
        style={{ "--typography-color": rest.color, ...style }}
        {...rest}
      >
        {children}
      </AntdText>
    )
  }, [children, className, rest, style])

  return block ? <div>{renderComponent()}</div> : renderComponent()
}

export default Text
